import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../../products/services';

/**
 * Generated class for the PhotoDishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'photo-product',
  templateUrl: 'photo-product.html',
})
export class PhotoProductPage {
  @Input() photo_width: string;
  @Input() photo_height: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public productsServices: ProductsServices,
    public globals: Globals) {
  }


  stylePhoto() {
    let styles = {
      'width': this.photo_width,
      'height': this.photo_height,
      'object-fit': 'cover'
    };
    return styles;
  }

  styleNoPhoto() {
    let styles = {
      'width': this.photo_width + ' !important;',
      'height': this.photo_height,
      'object-fit': 'contain'
    };
    return styles;
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/photo/photo-product/photo-product.ts